import React, { Component, PropType } from 'react';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import LoadingComponent from './LoadingComponent';

class ActivityComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        this.handleClick = this.handleClick.bind(this);
        this.generateActivityBody = this.generateActivityBody.bind(this);
        this.handleDateLabel = this.handleDateLabel.bind(this);
        this.triggerNotification = this.triggerNotification.bind(this);
    }

    componentDidMount() {
        jQuery('.selectpicker').selectpicker('refresh');

    }

    handleClick() {
        jQuery("#actionModal").modal('toggle');
    }

    handleDateLabel(datetime) {
        let dateFormatted = moment(datetime).format('YYYY/MM/DD HH:mm:ss');
        let dateLabel = moment(dateFormatted).endOf('day').fromNow();
        return dateLabel;
    }

    triggerNotification(elementData) {
        if (elementData) {
            triggerBrowser(elementData);
            // var postData = {
            //     siteId: this.props.dataSet.siteId,
            //     toolId: this.props.dataSet.toolId,
            //     id: id
            // }
            // CallAPI("POST","/app/pushNotfications",postData,null,null, function(response){
            //     if(response.success)
            //         alert("Notification sent successfully");
            //     else alert("Notification sent failed");
            // },this.props.authData);
        }
    }

    // gets the json array for activity list/Notfication and generates the activity body
    generateActivityBody() {
        let that = this;
        let activityCardConfig = this.props.result;
        let activityBody = activityCardConfig.map(function (element, i) {
            let url = element.url ? (element.url).replace('DASHBOARD_URL', location.origin) : '';
            let link = element.url ? <span><a href={url} target='_blank' style={{ color: 'blue' }}>Click Here</a></span> : null;
            return (
                <div>
                    <div id={`parent_${element['id']}`} key={`outer_${element['id']}`} className="media-body mg-t-40 mg-lg-t-0 pd-lg-x-200 mg-x-0 m-0">
                        <div key={`card_${element['id']}`} className="card mg-b-20 mg-lg-b-25">
                            {/*  30th November,2019 :Header commented as of now, will display when notfication header is available : Shreyansh Shekhar */}
                            {/* <div key={`cardHeader_${element['id']}`} className="card-header pd-y-10 pd-x-20 d-flex align-items-center justify-content-between">
                            <h6 className="tx-uppercase tx-semibold mg-b-0">Latest Activity</h6>
                            <span className="d-none d-sm-block tx-12 tx-color-03 mg-l-auto">{element['date_generated']}</span>
                        </div>  */}
                            {/* card-header */}
                            {/* <div className="card-body pd-lg-10">
                            <div className="col-md-12">
                                <h6 className="tx-uppercase tx-semibold mg-b-0">Latest Activity</h6>
                                <span className="d-none d-sm-block tx-12 tx-color-03 mg-l-auto">Today</span>
                            </div>
                            <p className="mg-y-5 pd-x-10">{element.text}</p>
                        </div> */}

                            <div className="card-body pd-lg-10">
                                {/* media --> */}
                                <div className="row col-md-12 pd-r-0">
                                    {/* <h6 className="tx-uppercase mg-b-0">{element.category}</h6> */}
                                    <h6>{element.category}  <i className="far fa-bell mg-r-10" data-toggle="tooltip" data-placement="bottom" title="Trigger Browser Notification" onClick={that.triggerNotification.bind(that, element)}></i></h6>
                                    <span className="d-none d-sm-block tx-12 tx-color-03 mg-l-auto">{that.handleDateLabel(element.date_generated)}</span>
                                </div>

                                {/* <p className="mg-y-10">{element.text}{url}</p> */}
                                <p className="mg-y-10">{element.text} {link}</p>
                                {/* activity message */}
                            </div>

                            {/* <div className="card-footer bg-transparent pd-y-10 pd-sm-y-10 pd-x-10 pd-sm-x-20">
                                <nav className="nav nav-with-icon ">
                                    <a href="#" onClick={that.handleClick} id={`likeButton_${element.id}`} className="nav-link">Like</a>
                                    // <a href="#" id={`commentButton_${element.id}`}  className="nav-link">Comment</a>
                                    <a htmlFor={`#parent_comment_${element['id']}`} id={`commentButton_${element.id}`} className="nav-link" data-toggle="collapse" href={`#parent_comment_${element['id']}`} aria-expanded="false" aria-controls={`parent_comment_${element['id']}`}>Comment</a>


                                    // <a href="#" onClick={that.handleClick} id={`shareButton_${element.id}`} className="nav-link">Share</a>
                                    <a data-target="#shareActionModal" data-toggle="modal" className="nav-link" id={`shareButton_${element.id}`} href="#shareActionModal">Share</a>

                                    <p className="nav-link mr-auto" id={`time_${element.id}`} href="#">{element['date_generated']}</p>
                                </nav>
                            </div> */}
                            {/* <!-- Card Action footer --> */}
                            <div className="">
                                <div id={`parent_comment_${element['id']}`} className="collapse">
                                    <textarea placeholder="Comments..." className="form-control" id={`parent_comment_${element['id']}`}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        });

        return activityBody;
    }

    render() {
        let mainBody = (this.props.result !== null && this.props.result !== undefined) ? this.generateActivityBody() : null;

        let list_of_users_options = [];
        if (JSON.parse(list_users).length > 0) {
            list_of_users_options = JSON.parse(list_users).map(function (innerData, index) {
                return <option value={innerData.value}>{innerData.label}</option>;
            });
        }

        return (
            <div>
                {mainBody}

                {/* <!-- User List Modal --> */}
                <div className="modal fade" id="shareActionModal" tabIndex="-1" role="dialog" aria-labelledby="shareActionModal" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="shareActionModal">Share Activity</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <select id={'share_to'} className="selectpicker" data-size="4" data-live-search="true" multiple required>
                                    {list_of_users_options}
                                </select>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-sm btn-primary">Share</button>
                                <button type="button" className="btn btn-sm btn-primary" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default ActivityComponent;
